module.exports = __webpack_public_path__ + "static/media/view-recipe-img.dc39c252.png";